import React, { useState } from 'react';
import SwotAnalysis from '../components/analysis/SwotAnalysis';
import TamAnalysis from '../components/analysis/TamAnalysis';
import { ChevronDown, ChevronUp, Save } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AuthService from '../Api_Module/Api_Services/AuthService';
import LoaderHelper from '../utility/Loading/LoaderHelper';
import { alertErrorMessage, alertSuccessMessage } from '../utility/CustomAlertMessage';

export function SwotAnalysisPage() {
  const [isSwotCollapsed, setIsSwotCollapsed] = useState(false);
  const [isTamCollapsed, setIsTamCollapsed] = useState(false);
  const { symbol } = useParams<{ symbol?: string }>();
  const researchData = useSelector((state: any) => state.researchData);

  const handleSave = async (type: 'SWOT' | 'TAM', e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      if (!symbol) {
        alertErrorMessage('No symbol provided for saving analysis');
        return;
      }
      LoaderHelper.loaderStatus(true);
      const result = await AuthService.saveStockResearchData(researchData, symbol);
      if (result) {
        alertSuccessMessage(`${type} analysis saved successfully!`);
      } else {
        alertErrorMessage(`Failed to save ${type} analysis`);
      }
    } catch (error: any) {
      alertErrorMessage(error?.message || `An error occurred while saving the ${type} analysis.`);
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <div className="w-full mx-auto space-y-4">
      {/* SWOT Analysis Section */}
      <div className="bg-theme-secondary rounded-lg shadow overflow-hidden border border-theme-tertiary">
        <div className="flex items-center justify-between p-3 border-b border-theme-tertiary cursor-pointer hover:bg-theme-tertiary/70 transition-colors" onClick={() => setIsSwotCollapsed(!isSwotCollapsed)}>
          <h2 className="text-sm font-semibold text-theme-primary">
            SWOT Analysis
          </h2>
          <div className="flex items-center gap-2">
            <button onClick={(e) => handleSave('SWOT', e)} className="flex items-center text-xs btn active btn-sm px-2 py-1 rounded-sm transition-colors">
              <Save size={12} className="mr-1" />
              Save
            </button>
            <div className="text-theme-muted hover:text-theme-primary transition-colors">
              {isSwotCollapsed ? <ChevronDown className="h-5 w-5" /> : <ChevronUp className="h-5 w-5" />}
            </div>
          </div>
        </div>
        {!isSwotCollapsed && (
          <div className="p-3">
            <SwotAnalysis />
          </div>
        )}
      </div>
      {/* TAM Analysis Section */}
      <div className="bg-theme-secondary rounded-lg shadow overflow-hidden border border-theme-tertiary">
        <div className="flex items-center justify-between p-3 border-b border-theme-tertiary cursor-pointer hover:bg-theme-tertiary/70 transition-colors" onClick={() => setIsTamCollapsed(!isTamCollapsed)}>
          <h2 className="text-sm font-semibold text-theme-primary">
            Total Addressable Market Analysis
          </h2>
          <div className="flex items-center gap-2">
            <button onClick={(e) => handleSave('TAM', e)} className="flex items-center text-xs btn active btn-sm px-2 py-1 rounded-sm transition-colors">
              <Save size={12} className="mr-1" />
              Save
            </button>
            <div className="text-theme-muted hover:text-theme-primary transition-colors">
              {isTamCollapsed ? <ChevronDown className="h-5 w-5" /> : <ChevronUp className="h-5 w-5" />}
            </div>
          </div>
        </div>
        {!isTamCollapsed && (
          <div className="p-3">
            <TamAnalysis />
          </div>
        )}
      </div>
    </div>
  );
}